<button
  appButton
  name="home"
  location="folder-breadcrumb"
  [hasIcon]="true"
  [color]="folder() ? 'simple' : 'simple-primary'"
  height="0"
  size="1"
  shape="round"
  (click)="selectFolder.emit(undefined)"
>
  <app-svg src="/assets/icons/house.svg" size="0"></app-svg>
  <span>Home</span>
</button>

@if (allItems()?.length > 2) {
  <app-svg src="/assets/icons/16/chevron-right.svg" class="chevron"></app-svg>
  <app-context-menu [options]="{ width: '260px', noSpacing: true }" #menu>
    <button
      appButton
      name="more"
      location="folder-breadcrumb"
      [iconButton]="true"
      [color]="folder ? 'simple' : 'simple-primary'"
      height="0"
      size="1"
      shape="round"
      contextButton
    >
      <app-svg src="/assets/icons/dots-horizontal.svg" size="0"></app-svg>
    </button>

    <div class="button-menu" contextContent>
      <button
        appButton
        name="home"
        location="folder-breadcrumb"
        [hasIcon]="true"
        [color]="'simple'"
        height="1"
        shape="round"
        spacing="full"
        (click)="selectFolder.emit(undefined); menu.close()"
      >
        <app-svg src="/assets/icons/house.svg"></app-svg>
        <span>Home</span>
      </button>

      @for (item of allItems(); track item.id) {
        <button
          appButton
          name="folder"
          location="folder-breadcrumb"
          [hasIcon]="true"
          [color]="folder()?.id === item.id ? 'simple-primary' : 'simple'"
          height="1"
          shape="round"
          spacing="full"
          (click)="selectFolder.emit(item); menu.close()"
        >
          <app-svg src="/assets/icons/folder.svg"></app-svg>
          <span>{{ item.title }}</span>
        </button>
      }
    </div>
  </app-context-menu>
}

@for (item of lastTwoItems(); track item.id) {
  <app-svg src="/assets/icons/16/chevron-right.svg" class="chevron"></app-svg>
  <button
    appButton
    name="folder"
    location="folder-breadcrumb"
    [hasIcon]="true"
    [color]="folder()?.id === item.id ? 'simple-primary' : 'simple'"
    height="0"
    size="1"
    shape="round"
    (click)="selectFolder.emit(item)"
  >
    <app-svg src="/assets/icons/folder.svg" size="0"></app-svg>
    <span>{{ item.title }}</span>
  </button>
}
